export default __webpack_public_path__ + "static/media/about.7e8676e8.jpeg";